import { render, staticRenderFns } from "./ProductQuestionForm.vue?vue&type=template&id=4b42d59e&"
import script from "./ProductQuestionForm.vue?vue&type=script&lang=js&"
export * from "./ProductQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports